import {combineReducers} from 'redux';
import scanningHistory from './ScanningHistory/reducer';

export default combineReducers({
    scanningHistory,
});
